import { getAuthHeaderProvider } from "@src/appV2/Auth/cognito/authHeaderProviderRef";
import { environmentConfig } from "@src/appV2/environment";
import request from "superagent";

export const getZendeskJWTMessagingSDK = async (): Promise<string> => {
  const token = await getAuthHeaderProvider()?.();

  // It has to use superagent because we don't want the axios interceptor to
  // modify the request headers. When we refactor this API to understand the
  // tokens in the headers, we can switch to axios, using the hooks.
  const { text } = await request.get(
    `${environmentConfig.REACT_APP_ZENDESK_JWT_MICROSERVICE_BASE_URL}/zendesk/sdk/jwt-messaging/${token}`
  );
  return text;
};
